import ApiRequest from "../index"

const paymentsPolicy = {
  get: async data => ApiRequest.get(`/v2/lojinha/complements/payment`),
  put: async data => ApiRequest.put(`/v2/lojinha/complements/payment`, { ...data })
}

export default paymentsPolicy
